<template>
    <div>
        <v-card flat :loading="loading">
            <v-card-title>Billing Calendar</v-card-title>
            <v-card-subtitle>Visualize when the invoices will be generated automatically</v-card-subtitle>
            <v-card-text>
                <v-sheet height="64">
                    <v-toolbar flat color="white">
                        <v-btn outlined class="mr-4" color="grey darken-2" @click="setToday">
                            Today
                        </v-btn>
                        <v-btn fab text small color="grey darken-2" @click="prev">
                            <v-icon small>mdi-chevron-left</v-icon>
                        </v-btn>
                        <v-btn fab text small color="grey darken-2" @click="next">
                            <v-icon small>mdi-chevron-right</v-icon>
                        </v-btn>
                        <v-toolbar-title>{{ title }}</v-toolbar-title>
                        <v-spacer></v-spacer>
                        <v-menu bottom right>
                            <template v-slot:activator="{ on }">
                                <v-btn outlined color="grey darken-2" v-on="on">
                                    <span>{{ typeToLabel[type] }}</span>
                                    <v-icon right>mdi-menu-down</v-icon>
                                </v-btn>
                            </template>
                            <v-list>
                                <v-list-item @click="type = 'day'">
                                    <v-list-item-title>Day</v-list-item-title>
                                </v-list-item>
                                <v-list-item @click="type = '4day'">
                                    <v-list-item-title>4 days</v-list-item-title>
                                </v-list-item>
                                <v-list-item @click="type = 'week'">
                                    <v-list-item-title>Week</v-list-item-title>
                                </v-list-item>
                                <v-list-item @click="type = 'month'">
                                    <v-list-item-title>Month</v-list-item-title>
                                </v-list-item>
                            </v-list>
                        </v-menu>
                    </v-toolbar>
                </v-sheet>
                <v-sheet height="600">
                    <v-calendar ref="calendar" v-model="focus" color="primary" :type="type" :events="events" :now="today" :event-color="getEventColor" @click:event="eventSelected" @click:more="viewMore" @change="updateRange"></v-calendar>
                    <v-menu v-model="selectedOpen" :close-on-content-click="false"  :activator="selectedElement" offset-y max-width="350px">
                        <v-card color="white" width="350px" flat>
                            <v-card-title>{{ selectedEvent.name }}</v-card-title>
                            <v-card-text>
                                <table style="width: 100%;">
                                    <tr>
                                        <td>From:</td>
                                        <td>{{ selectedEvent.start }}</td>
                                    </tr>
                                    <tr>
                                        <td>To:</td>
                                        <td>{{ selectedEvent.end }}</td>
                                    </tr>
                                </table>
                            </v-card-text>
                            <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn text color="secondary" @click="selectedOpen = false" >
                                    Cancel
                                </v-btn>
                            </v-card-actions>
                        </v-card>
                    </v-menu>
                </v-sheet>
            </v-card-text>
        </v-card>
    </div>
</template>

<script>
import moment from 'moment'
export default {
    data() {
        return {
            focus: '',
            events: [],
            type: 'month',
            start: null,
            end: null,
            typeToLabel: {
                month: 'Month',
                week: 'Week',
                day: 'Day',
                '4day': '4 Days',
            },
            selectedEvent: {},
            selectedElement: null,
            selectedOpen: false,
            colors: ['blue', 'indigo', 'deep-purple', 'cyan', 'green', 'orange', 'grey darken-1'],
            names: ['Meeting', 'Holiday', 'PTO', 'Travel', 'Event', 'Birthday', 'Conference', 'Party'],
            today: new Date().toISOString().substr(0, 10),

            loading: false,
        }
    },
    mounted() {
        this.init();
    },
    computed: {
        title () {
            const { start, end } = this;
            if (!start || !end) {
                return '';
            }

            const startMonth = this.monthFormatter(start);
            const endMonth = this.monthFormatter(end);
            const suffixMonth = startMonth === endMonth ? '' : endMonth;

            const startYear = start.year;
            const endYear = end.year;
            const suffixYear = startYear === endYear ? '' : endYear;

            const startDay = start.day + this.nth(start.day);
            const endDay = end.day + this.nth(end.day);

            switch( this.type ) {
            case 'month':
                return `${startMonth} ${startYear}`;
            case 'week':
            case '4day':
                return `${startMonth} ${startDay} ${startYear} - ${suffixMonth} ${endDay} ${suffixYear}`;
            case 'day':
                return `${startMonth} ${startDay} ${startYear}`;
            }
            return '';
        },
        monthFormatter () {
            return this.$refs.calendar.getFormatter({
                timeZone: 'UTC', month: 'long',
            });
        },
    },
    methods: {
        init() {
            this.loading = true;
            this.loadCalendar();
        },
        getEventColor( event ) {
            if( event.color == ' !important' )
                return '#cdcdcd';

            return event.color;
        },
        eventSelected({ nativeEvent, event }) {
            if( event.invoiceId != undefined && event.invoiceId != null ) {
                this.downloadInvoice( event );
                return;
            }

            const open = () => {
                this.selectedEvent = event;
                this.selectedElement = nativeEvent.target;
                setTimeout( () => this.selectedOpen = true, 10 );
            }

            if( this.selectedOpen ) {
                this.selectedOpen = false;
                setTimeout( open, 10 );
            } else 
                open();

            nativeEvent.stopPropagation()
        },
        downloadInvoice( event ) {
            
            if( event.invoiceId == undefined || event.invoiceId == null )
                return;

             this.$http
                .get( '/proc/data.php', {
                    params: {
                        action: 'downloadInvoice',
                        id: event.invoiceId
                    },
                    responseType: 'blob',
                } )
                .then( response => { 
                    if( response.data.message == 'Unauthorized' ) 
                        this.$router.push('/login');
                        
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', `Invoice #${event.invoiceId}.pdf`); //or any other extension
                    document.body.appendChild(link);
                    link.click();
                });
        },
        setToday() {
            this.focus = this.today;
            this.loadCalendar( moment( this.focus ).format('M'), moment( this.focus ).format('Y') );
        },
        updateRange({ start, end }) {
            this.start = start;
            this.end = end;
        },
        prev() {
            this.$refs.calendar.prev();
            this.loadCalendar( moment( this.focus ).format('M'), moment( this.focus ).format('Y') );
        },
        next() {
            this.$refs.calendar.next();
            this.loadCalendar( moment( this.focus ).format('M'), moment( this.focus ).format('Y') );
        },
        nth( d ) {
            return d > 3 && d < 21 ? 'th' : ['th', 'st', 'nd', 'rd', 'th', 'th', 'th', 'th', 'th', 'th'][d % 10];
        },
        viewMore( event ) {
            this.focus = event.date;
            this.type = 'day';
        },
        formatDate( a, withTime ) {
            return withTime
            ? `${a.getFullYear()}-${a.getMonth() + 1}-${a.getDate()} ${a.getHours()}:${a.getMinutes()}`
            : `${a.getFullYear()}-${a.getMonth() + 1}-${a.getDate()}`
        },
        loadCalendar( month = null, year = null ) {
            // if( month == null )
            //     month = moment( this.focus ).format('M');
            // if( year == null )
            //     year = moment( this.focus ).format('Y');

            this.loading = true;
            this.$http
                .get( '/proc/data.php', {
                    params: {
                        action: 'getBillingCalendar',
                        month: month,
                        year: year
                    }
                })
                .then( response => { 
                    if( response.data.message == 'Unauthorized' ) 
                        this.$router.push('/login');

                    this.loading = false;
                    this.events = response.data;
                });
        }
    }
}
</script>

<style>
.v-calendar .v-calendar-daily_head-day {
    max-height: 300px;
    overflow: auto;
}
</style>